module.exports = __webpack_public_path__ + "img/flower-cycle.d74b6aa5.svg";